import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/nodata-icon.png';
const _hoisted_1 = {
  class: "nodata"
};
const _hoisted_2 = {
  class: "tips"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1 /* CACHED */)), _createElementVNode("p", _hoisted_2, _toDisplayString($props.tips), 1 /* TEXT */)]);
}